module.exports = __webpack_public_path__ + "static/media/NFS_PNG-01.c9675b81.png";